import { Link } from '@inertiajs/react';
import { motion } from 'motion/react';

import TopWantedActions from '@/theme1/components/topWanted/TopWantedActions';
import TopWantedPrice from '@/theme1/components/topWanted/TopWantedPrice';

export default function TopWantedItem({ product, index }) {
    const isTopProduct = product.rank === 1 || product.isTopRated;
    const cardClasses = isTopProduct
        ? 'border-amber-200/80 bg-gradient-to-br from-stone-50 via-white to-amber-50/70 shadow-[0_18px_45px_-24px_rgba(245,158,11,0.45)]'
        : 'border-slate-200/80 bg-gradient-to-br from-white via-white to-slate-50/80 shadow-[0_18px_45px_-24px_rgba(15,23,42,0.16)]';
    const rankClasses = isTopProduct
        ? 'bg-neutral-950 text-white'
        : 'border border-slate-200 bg-white text-slate-900';
    const imageFrameClasses = isTopProduct
        ? 'border border-amber-100/90 bg-amber-50/40'
        : 'border border-slate-200/70 bg-slate-100/60';

    return (
        <motion.article
            initial={{ opacity: 0, y: 26 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-50px' }}
            transition={{ duration: 0.5, delay: index * 0.05 }}
            whileHover={{ y: -4 }}
            className={`relative h-[200px] overflow-hidden rounded-[2rem] border p-3 transition sm:h-[210px] sm:p-4 ${cardClasses}`}
        >
            {isTopProduct ? (
                <div className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-amber-300 via-orange-400 to-amber-200" />
            ) : null}

            <div className={`absolute left-0 top-4 z-10 rounded-r-lg px-3 py-1.5 text-xs font-black ${rankClasses}`}>
                #{product.rank}{isTopProduct ? ' Top Rated' : ''}
            </div>

            <div className="flex h-full min-w-0 gap-3 pt-7 sm:gap-5 sm:pt-5">
                <div className="flex w-[120px] shrink-0 items-center justify-center sm:w-[150px] md:w-[170px]">
                    <Link
                        href={`/products/${product.slug}`}
                        className={`group flex h-[120px] w-full items-center justify-center overflow-hidden rounded-[1.25rem] focus:ring-2 focus:ring-neutral-950 focus:ring-offset-2 focus:outline-none ${imageFrameClasses}`}
                    >
                        <img
                            src={product.image}
                            alt={`${product.title} product view`}
                            loading="lazy"
                            className="max-h-[120px] max-w-full object-contain transition duration-700 group-hover:scale-105"
                        />
                    </Link>
                </div>

                <div className="flex min-w-0 flex-1 flex-col">
                    <Link
                        href={`/products/${product.slug}`}
                        className={`line-clamp-1 block font-black tracking-tight uppercase transition hover:text-muted-foreground ${
                            isTopProduct
                                ? 'text-lg sm:text-xl md:text-2xl'
                                : 'text-base sm:text-lg md:text-xl'
                        }`}
                    >
                        {product.title}
                    </Link>

                    <div className="mt-2">
                        <TopWantedPrice
                            price={product.price}
                            comparePrice={product.comparePrice}
                            discount={product.discount}
                        />
                    </div>

                    <p className="mt-2 line-clamp-2 max-w-2xl text-xs leading-5 text-muted-foreground sm:text-sm">
                        {product.description}
                    </p>

                    <div className="mt-auto w-full pt-2">
                        <TopWantedActions product={product} />
                    </div>
                </div>
            </div>
        </motion.article>
    );
}
